let Mra = {
    init: function () {
        if ($('body.mra').length) {
            this.bind();
        }
    },

    bind: function () {
        this.listenForFieldChanges();
        this.toggleFields();
        this.form();
    },

    listenForFieldChanges() {
        let _this = this;

        $(document).on('change', '[name=status]', function () {
            _this.toggleFields();
        });

        $(document).on('change', '[name=type]', function () {
            _this.toggleFields();
        });

        $(document).on('change', '#mraParties', function () {
            _this.toggleFields();
        });
    },

    toggleFields() {
        let status = $('input[name=status]:checked').val();
        let type = $('input[name=type]:checked').val();
        const is_edit = $('#is_edit').val() == 1 ? true : false;
        const is_admin = $('#is_admin').val() == 1 ? true : false;

        if (status === 'signed' || status === 'operational') {
            $('#dateSignedContainer').show();
        } else {
            $('#dateSignedContainer').hide();
        }

        if (status === undefined) {
            $('#dateSignedContainer').hide();
        }

        const partiesSelect = $('#mraParties');

        if (type === 'bilateral') {
            let partiesSelected = partiesSelect.val();
            partiesSelected = partiesSelected.slice(0, 2);

            if (!is_admin && !is_edit) {
                if (partiesSelected.indexOf($('#main_union').val()) === -1) {
                    partiesSelected.unshift($('#main_union').val());
                    partiesSelected = partiesSelected.slice(0, 2);
                }
            }

            partiesSelect.val(partiesSelected);

            partiesSelect.select2({
                maximumSelectionLength: 2,
                ajax: {
                    url: '/api/parties/aeo',
                    dataType: 'json',
                    processResults: function (data) {
                        return {
                            results: data.data
                        };
                    },
                    data: function (params) {
                        params.parties = $('#mraParties').val();

                        // Query parameters will be ?search=[term]&type=public
                        return params;
                    }
                }
            });

        } else {
            partiesSelect.select2({
                ajax: {
                    url: '/api/parties/aeo',
                    dataType: 'json',
                    processResults: function (data) {
                        return {
                            results: data.data
                        };
                    },
                    data: function (params) {
                        params.parties = $('#mraParties').val();

                        // Query parameters will be ?search=[term]&type=public
                        return params;
                    }
                }
            });
        }

        if (!is_admin && !is_edit) {
            if (!partiesSelect.val().length) {
                partiesSelect.val([$('#main_union').val().toString()]).trigger('change');
            }

            partiesSelect.on('select2:unselecting', function (e) {
                if (e.params.args.data.id == $('#main_union').val()) {
                    return false;
                }
            });
        }
    },

    form() {
        $(document).on('click', 'button[type=submit]', function () {
            const action = $(this).data('action');

            if (action === 'submit_to_wco') {
                Swal.fire({
                    title: 'Are you sure?',
                    showCancelButton: true,
                    confirmButtonText: 'Continue',
                    cancelButtonText: 'Cancel',
                    icon: 'warning'
                }).then((result) => {
                    if (result.value) {
                        $('#aeoForm #action').val(action);
                        $('#aeoForm #processing_status').val('submitted');
                        $('#aeoForm').submit();
                    } else {
                        $('input[type="submit"]').removeAttr('disabled');
                        $('button[type="submit"]').removeAttr('disabled');
                    }
                });
            } else {
                $('#aeoForm #action').val(action);
                $('#aeoForm').submit();
            }
        });
    },
};


$().ready(() => {
    window.Mra = Mra;
    window.Mra.init();
});
